<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Agregar Dispositivo</b-card-header>
      <b-card-body>
        <div v-if="MostrarMensajeResuesta == false">
          <div class="row" style="margin-top: 10px">
            <div class="col-md-12 text-center">
              <label class="text-center" style="font-size: 16px;">Asociá un dispositivo a tu cuenta</label>
            </div>
            <div class="col-md-12 text-center">
              <img src="@/assets/device-gray.png" style="width: 150px;" />
            </div>
          </div>
          <br />
          <div class="row justify-content-center">
            <div class="col-md-7 text-center">
              <label
                style="font-size: 16px;"
              >Ingresá el Número de Serie (SN) del dispositivo que deseás agregar.</label>
              <base-input v-model="IMEI" placeholder="Número de Serie"></base-input>
            </div>
          </div>

          <div v-if="AcceptTermsAndConditions == false">
            <div class="row" style="margin-top:20px;margin-bottom:20px;">
              <div class="col-md-12 text-center">
                <b-form-checkbox v-model="AcceptTermsConditions">
                  <a
                    href="https://www.resimple.com.ar/legales/"
                    target="_blank"
                  >Acepto términos y condiciones</a>
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <div class="row" style="margin-bottom: 10px">
            <div class="col-md-12 text-center">
              <div v-if="AcceptTermsConditions">
                <button class="btn btn-success" type="button" @click="agregarDispositivo()">
                  <i class="fa fa-plus-circle fa-fw"></i>Agregar
                </button>
              </div>
              <div v-else>
                <button class="btn btn-success" disabled type="button">
                  <i class="fa fa-plus-circle fa-fw"></i>Agregar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-md-12 text-center">
              <base-alert :type="resultadoRespuesta.Tipo">
                <span class="alert-inner--icon" style="font-size: 90px;">
                  <i :class="resultadoRespuesta.Icono"></i>
                </span>
                <br />
                <div
                  class="col-md-12 text-center"
                  style="font-size:17px"
                  v-if="resultadoRespuesta.Titulo != ''"
                >
                  <span
                    class="alert-inner--text"
                    style="font-weight: bold"
                    v-html="resultadoRespuesta.Titulo"
                  ></span>
                  <br />
                  <br />
                </div>
                <span
                  class="alert-inner--text"
                  style="font-weight: bold"
                  v-html="resultadoRespuesta.Texto"
                ></span>
              </base-alert>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="goBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  props: {
    AcceptTermsAndConditions: Boolean
  },
  data() {
    return {
      IMEI: "",
      MostrarMensajeResuesta: false,
      resultadoRespuesta: {
        Titulo: "",
        Texto: "",
        Tipo: "",
        Icono: "",
        Exito: false
      },
      AcceptTermsConditions: this.AcceptTermsAndConditions
    };
  },
  methods: {
    agregarDispositivo() {
      let context = this;
      axiosHelpers.axiosPostWithoutAlerts(
        "Commerce/AssociateAccessoryToCommerce",
        {
          AccessoryIdentifier: context.IMEI,
          AcceptTerms: context.AcceptTermsConditions
        },
        this,
        function(data) {
          context.MostrarMensajeResuesta = true;
          if (data.ResponseVM.Result) {
            context.resultadoRespuesta = {
              Titulo: "",
              Texto: "El dispositivo se agregó con éxito!",
              Tipo: "success",
              Icono: "fa fa-fw fa-check-circle",
              Exito: true
            };
          } else if (data.Alerts.length > 0) {
            context.resultadoRespuesta = {
              Titulo: "",
              Texto: data.Alerts[0].Message,
              Tipo: "danger",
              Icono: "fa fa-fw fa-times-circle",
              Exito: false
            };
          } else if (
            data.ResponseVM.Message != null &&
            data.ResponseVM.Message != ""
          ) {
            context.resultadoRespuesta = {
              Titulo: "Habilitación de dispositivo pendiente.",
              Texto: data.ResponseVM.Message,
              Tipo: "warning",
              Icono: "fa fa-fw fa-info-circle",
              Exito: false
            };
          }
        }
      );
    },
    goBack() {
      this.$router.push("MisDispositivos");
    }
  },
  watch: {
    IMEI: function(newValue, oldValue) {
      this.IMEI = this.IMEI.toUpperCase();
    }
  }
};
</script>